export const ALL_MEDIA = 'all';
export const PHOTO_MEDIA = 'image';
export const VIDEO_MEDIA = 'video';
export const AUDIO_MEDIA = 'audio';
